export default class GridTools {
	constructor() {
		
	}

	drawGrid(canvas, gridEnabled, gridSize) {
		if (!canvas) return;
		canvas.getObjects('line').forEach(line => {
			if (line.gridLine) canvas.remove(line);
		});
		if (!gridEnabled) {
			canvas.renderAll();
			return;
		}
		for (let i = gridSize; i < canvas.width; i += gridSize) {
			const vLine = new window.fabric.Line([i, 0, i, canvas.height], {
				stroke: '#ccc', selectable: false, evented: false, gridLine: true
			});
			canvas.add(vLine);
			vLine.sendToBack();
		}
		for (let i = gridSize; i < canvas.height; i += gridSize) {
			const hLine = new window.fabric.Line([0, i, canvas.width, i], {
				stroke: '#ccc', selectable: false, evented: false, gridLine: true
			});
			canvas.add(hLine);
			hLine.sendToBack();
		}
		//canvas.renderAll();
	}
}